// `text.generate`: live's `TEXT_GENERATION`, one LLM call a template's step writes (spec
// G14-templates, "The steps"). Live lists no such job; a template's run starts it.
import { TextGenerateQuote, TextGenerateRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"text.generate"> = {
  type: "text.generate",
  label: "Text",
  source: "form",
  pair: "text.generate",
  fields: () => ({}),
  request: TextGenerateRequest,
  quote: TextGenerateQuote,
};
